<template>
  <main>
    <OrganismInitialSetup/>
  </main>
</template>

<script>
export default {
  name: 'InitialSetup',

  components: {
    OrganismInitialSetup: () => import('@/components/organisms/OrganismInitialSetup')
  }
}
</script>
